import React, { useEffect, useState } from 'react'
import SmallModal from './SmallModal'
import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'
import Lottie from 'lottie-react'
import formSubmission from '../../assets/lottie/success.json'
import Button from '@mui/material/Button'
import { Typography } from '@mui/material'

const SuccessModal = ({
  open,
  countdown,
  navTo,
  newUrl,
  message,
  ...props
}) => {
  const [count, setCount] = useState(countdown ?? 10)
  const navigate = useNavigate()

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (count > 0) {
          setCount(count - 1)
        } else {
          clearTimeout()
          navigate('/')
        }
      }, 1000)
    }
  }, [count, open])

  return (
    <SmallModal open={open}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        gap={1}
      >
        <Lottie animationData={formSubmission} loop={false} />
        <Typography
          align="center"
          fontSize={'1.3rem'}
          sx={{ color: '#008767' }}
          variant="caption"
        >
          {message ?? 'Your form was submitted successfully!'}
        </Typography>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-around"
          gap={2}
        >
          <Button
            color="secondary"
            size="small"
            onClick={() => navigate('/')}
            sx={{ fontSize: '0.7rem', flexGrow: 1, display: 'flex' }}
          >
            Dashboard ({count})
          </Button>
          <Button
            color="info"
            size="small"
            onClick={() => window.location.reload()}
            sx={{ fontSize: '0.7rem' }}
          >
            Add New
          </Button>
        </Box>
      </Box>
    </SmallModal>
  )
}

export default SuccessModal
